import { IPassageReference } from "../../properties/ActivityProperties";

interface PassageReferenceBlockProps {
  reference: IPassageReference;
}

const PassageReferenceBlock = ({ reference }: PassageReferenceBlockProps) => {
  const { title, author, year, url, note } = reference;
  const hasCitation = title || author;
  if (!hasCitation && !note) return null;

  const renderCitation = () => {
    if (!hasCitation) return null;
    const parts: string[] = [];
    if (title) parts.push(`"${title}"`);
    if (author) parts.push(`by ${author}`);
    if (year != null) parts.push(`(${year})`);
    const citationText = parts.join(" ");
    return url ? (
      <a
        href={url}
        target="_blank"
        rel="noreferrer noopener"
        className="am-cite-link"
      >
        {citationText}
      </a>
    ) : (
      <span className="am-cite">{citationText}</span>
    );
  };

  return (
    <div className="am-cite-wrap">
      {hasCitation ? (
        <span>
          Adapted from {renderCitation()}
          {note ? ` — ${note}` : null}
        </span>
      ) : (
        <span>{note}</span>
      )}
    </div>
  );
};

export default PassageReferenceBlock;
